var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogFormVisible,
        title: "咨询项选择",
        width: "560px"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        }
      }
    },
    [
      _c("el-tree", {
        ref: "tree",
        staticStyle: { height: "420px", "overflow-y": "auto" },
        attrs: {
          data: _vm.showConsults,
          "default-expanded-keys": _vm.assignedConsults,
          "default-checked-keys": _vm.assignedConsults,
          "show-checkbox": "",
          "node-key": "id",
          "highlight-current": ""
        },
        on: { check: _vm.handleNodeChange },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var node = ref.node
              var data = ref.data
              return _c(
                "span",
                { staticClass: "custom-tree-node" },
                [
                  _c("span", [_vm._v(_vm._s(data.name))]),
                  _vm._v(" "),
                  data.notify
                    ? _c(
                        "el-tag",
                        {
                          attrs: {
                            type: "success",
                            title: data.notify,
                            size: "mini"
                          }
                        },
                        [_vm._v("?")]
                      )
                    : _vm._e()
                ],
                1
              )
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.assignedConsultsName
        ? _c(
            "div",
            { staticStyle: { padding: "10px 0", "font-size": "12px" } },
            [
              _c("span", { staticStyle: { color: "#09afff" } }, [
                _vm._v(
                  "选中" + _vm._s(_vm.assignedConsultsName.length) + "项："
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.assignedConsultsName, function(item) {
                return _c(
                  "el-tag",
                  { staticStyle: { "margin-right": "5px" } },
                  [_vm._v(_vm._s(item))]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.limit > 0 && _vm.assignedConsultsName.length > _vm.limit
        ? _c("div", { staticStyle: { color: "red", "font-size": "12px" } }, [
            _vm._v(
              "超过限定数量" +
                _vm._s(_vm.limit) +
                "项，将无法确认，请重新选择！"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSelected } },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }